export default __webpack_public_path__ + "static/media/feature-1.d64fa827.svg";